import { useEffect, useRef } from "react";

import useFirebase from "../Hooks/useFirebase";
import useDBAuth from "../Hooks/useDBAuth";

import Page_Login from "./Page_Login";
import Page_Cafe_POS from "./Page_Cafe_POS";

import { Button } from "@mantine/core";

export default function X(props) {
  // --------------------------------------- auth User
  const [firebase_Status, firebase_SignOut, firebase_LoginUI] = useFirebase();
  const [dbAuth_Status, dbAuth_Login_Obj] = useDBAuth();

  const renderLimit = useRef(2);
  if (firebase_Status?.login_Status === true && renderLimit.current > 0) {
    // console.log("P1");
    dbAuth_Login_Obj.u_email = firebase_Status?.userInfo_Email;
    renderLimit.current--;
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {firebase_Status?.login_Status === false ? (
        <Page_Login />
      ) : dbAuth_Status?.Auth_Login === true ? (
        <>
          {/* Sticky navbar at the top */}
          <div
            style={{
              position: "sticky",
              top: 0,
              zIndex: 1000,
              backgroundColor: "rgba(22, 22, 22, 0.1)",
              backdropFilter: "blur(10px)",
              WebkitBackdropFilter: "blur(10px)",
              borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
              padding: "0.5rem 1rem",
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
            }}
          >
            <Button
              variant="subtle"
              color="red"
              onClick={() => {
                firebase_SignOut();
              }}
            >
              <div className="FlexRow">
                <img
                  src={firebase_Status?.userInfo_PhotoURL}
                  height="25rem"
                  style={{
                    borderRadius: "20rem",
                    marginRight: "1rem",
                  }}
                  alt="User profile"
                />
                <div>LOGOUT</div>
              </div>
            </Button>
          </div>
          <Page_Cafe_POS />
        </>
      ) : (
        "Loading..."
      )}
    </>
  );
}
